module.exports = __webpack_public_path__ + "static/media/connect-api-logo.46d15d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/connect-api-logo.png
// module id = 272
// module chunks = 0